import { ReactElement } from 'react';
import { useDrawerContentAtom } from '../../atoms';

type DrawerContentRouteProps = {
    to: string;
    children: ReactElement;
};

export const DrawerContentRoute: React.FC<DrawerContentRouteProps> = ({ to, children }) => {
    const { drawerContent } = useDrawerContentAtom();

    return drawerContent === to ? children : null;
};
